import { useEffect, useState } from 'react';

/** Safety cap — never block layout on fonts longer than this. */
const FONTS_READY_MAX_WAIT_MS = 3000;

let fontsReadyResolved =
  typeof document === 'undefined' || !document.fonts || document.fonts.status === 'loaded';

/**
 * True once webfonts have finished loading (document.fonts.ready) or the safety cap elapsed.
 *
 * Card heights are measured from the DOM; if measurement wins the race against the Inter
 * webfont swap, ELK lays the board out with fallback-font metrics and every session produces
 * slightly different coordinates (the "daily drift"). Gating the post-measure ELK pass on
 * fonts guarantees the settled layout of a session is always computed from final text metrics.
 */
export function useFontsReady() {
  const [ready, setReady] = useState(fontsReadyResolved);

  useEffect(() => {
    if (ready) return undefined;
    let active = true;
    const markReady = () => {
      fontsReadyResolved = true;
      if (active) setReady(true);
    };
    document.fonts.ready.then(markReady).catch(markReady);
    const cap = window.setTimeout(markReady, FONTS_READY_MAX_WAIT_MS);
    return () => {
      active = false;
      window.clearTimeout(cap);
    };
  }, [ready]);

  return ready;
}
